import { createFileRoute } from '@tanstack/react-router';
import { FileText } from 'lucide-react';
import { Header, PageContainer } from '@/components/layout';
import { Card, EmptyState } from '@/components/ui';

export const Route = createFileRoute('/documents')({
  component: DocumentsPage,
});

function DocumentsPage() {
  return (
    <>
      <Header title="Documents" subtitle="Manage your markdown documents and templates" />
      <PageContainer>
        <Card>
          <EmptyState
            icon={FileText}
            title="Coming Soon"
            description="Document management with markdown editor is under development"
          />
        </Card>
      </PageContainer>
    </>
  );
}
